/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-11 10:01:46
 * @LastEditors: changfeng
 * @LastEditTime: 2024-05-15 18:20:47
 */
import { useEffect, useState } from "react";
import { Divider, Form, Input, message, Modal, Spin } from "antd";
import { getAddTeamMember } from "@/api/modules/team";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const InviteTeamMember = (props: any) => {
	const { t } = useTranslation();

	const { open, onClose, onOkCallBack } = props;
	const { language } = useSelector(state => state.global);

	const [email, setEmail] = useState<string>();
	const [isLoading, setIsLoading] = useState(false);
	const [form] = Form.useForm();

	const handlerEmailChange = event => {
		setEmail(event.target.value);
	};

	useEffect(() => {
		setEmail("");
	}, [open]);

	const handleOnClose = () => {
		setEmail("");
		setIsLoading(false);
		onClose();
	};

	const invite = () => {
		setIsLoading(true);
		try {
			const params = {
				email: email,
				language: language
			};

			getAddTeamMember(params)
				.then(res => {
					if (res.code === 200) {
						message.success(t("teamSettings.team.invite.success.message"));
						onClose();
						form.resetFields();
						onOkCallBack();
					}
					setIsLoading(false);
				})
				.catch(e => {
					setIsLoading(false);
				});
		} catch (e) {
			setIsLoading(false);
		}
	};

	console.log("isLoading", isLoading);
	return (
		<Modal
			open={open}
			title={t("teamSettings.team.invite.modal.title")}
			okText={t("teamSettings.team.invite.modal.ok")}
			onOk={() => invite()}
			confirmLoading={isLoading}
			destroyOnClose={true}
			onCancel={handleOnClose}
		>
			<Spin spinning={isLoading}>
				<Divider style={{ margin: 0 }} />
				<Form form={form} style={{ width: "100%", marginTop: "1rem" }} labelCol={{ span: 24 }}>
					<Form.Item label={t("teamSettings.team.invite.modal.label")}>
						<Input value={email} placeholder={t("teamSettings.team.invite.modal.placeholder")} onChange={handlerEmailChange} />
					</Form.Item>
				</Form>
			</Spin>
		</Modal>
	);
};

export default InviteTeamMember;
